// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"Breadcrumbs-module--breadcrumbs--1FfSh","breadcrumbs__links":"Breadcrumbs-module--breadcrumbs__links--1rNpE"};